.notificationtext {
  @media only screen and (max-width: 400px) {
    margin-right: 0px;
  }
  margin-right: 12px;
  margin-bottom: 30px;
  font-size: 1.2em;
  font-weight: bold;
  color: #0054A6;
}
